import script from "./AdminAddApartment.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAddApartment.vue?vue&type=script&setup=true&lang=js"

import "./AdminAddApartment.vue?vue&type=style&index=0&id=13061a50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13061a50"]])

export default __exports__